module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/user-details/user-details.component.css
// module id = ./src/app/components/user-details/user-details.component.css
// module chunks = main